import Badge from 'components/Project/Project/Step/Badge/Badge'
import coderImage from 'components/Project/Project/Step/KnowledgeQuiz/Results/images/coder.png'
import NavigationContainer from 'components/Project/Project/Step/Navigation/NavigationContainer'
import { projectHasBadge } from 'helpers/Step'
import PropTypes from 'prop-types'
import { withNamespaces } from 'react-i18next'

import './Results.scss'

export const Results = (props) => {
  const {
    t,
    quizAttempt,
    retryQuiz,
    badge,
    project,
    loading,
    authentication,
    slug,
  } = props

  return (
    <div className="c-project-steps__wrapper">
      {loading && <div />}
      {!loading &&
        (projectHasBadge(project) &&
        badge?.badge &&
        badge?.badge?.badge_template_id === project?.badgeTemplateId ? (
          <Badge
            authentication={authentication}
            badge={badge}
            slug={slug}
            projectTitle={project.title}
            quizAttempt={quizAttempt}
            retryQuiz={retryQuiz}
          />
        ) : (
          <div className="knowledge-quiz-results">
            <div className="knowledge-quiz-results__layout">
              <div className="knowledge-quiz-results__blurb">
                <h2 className="knowledge-quiz-results__heading knowledge-quiz-results__heading--small">
                  {t('quiz.complete')}
                </h2>
                <h3 className="knowledge-quiz-results__heading">
                  {t('quiz.well_done')}
                </h3>
                <p className="knowledge-quiz-results__text">
                  {t('quiz.end_text')}
                </p>
              </div>
              <div className="knowledge-quiz-results__image-holder">
                <img
                  alt=""
                  className="knowledge-quiz-results__image"
                  src={coderImage}
                />
              </div>
            </div>
            <input
              type="button"
              onClick={retryQuiz}
              value={t('quiz.try_again')}
            />
          </div>
        ))}
      <NavigationContainer />
    </div>
  )
}

Results.propTypes = {
  authentication: PropTypes.object,
  t: PropTypes.func.isRequired,
  quizAttempt: PropTypes.object.isRequired,
  retryQuiz: PropTypes.func.isRequired,
  badge: PropTypes.object.isRequired,
  slug: PropTypes.string,
  project: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired,
  currentStepPosition: PropTypes.number.isRequired,
}

export default withNamespaces('translations')(Results)
